// export const REGIMES = [
//   { value: 'APOSENTADO', label: 'Aposentado' }, { value: 'CELETISTA', label: 'Celetista' },
//   { value: 'COMISSIONADO', label: 'Comissionado' }, { value: 'EFETIVO', label: 'Efetivo' },
//   { value: 'ESTATUTARIO', label: 'Estatutário' }, { value: 'PENSIONISTA', label: 'Pensionista' },
//   { value: 'TEMPORARIO', label: 'Temporário' }
// ];

export const REGIMES = [
  { value: 'APOSENTADO_PENSIONISTA', label: 'Aposentado/Pensionista' },
  { value: 'CELETISTA', label: 'Celetista' },
  { value: 'COMISSIONADO', label: 'Comissionado' },
  { value: 'EFETIVO', label: 'Efetivo' },
  { value: 'TEMPORARIO', label: 'Temporário' },
  { value: 'OUTROS', label: 'Outros' }
];
